module.exports = __webpack_public_path__ + "media/Images/icon-create-another-1594fdb014c2b975d75be379b8d02a8a.svg";